import script from "./MessageCenter.vue?vue&type=script&setup=true&lang=js"
export * from "./MessageCenter.vue?vue&type=script&setup=true&lang=js"

import "./MessageCenter.vue?vue&type=style&index=0&id=a4390598&scoped=true&lang=css"
script.__scopeId = "data-v-a4390598"

export default script